























import { Mixins, Component, Prop, Emit } from 'vue-property-decorator'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'

@Component
export default class TcwFormItemSwitch extends Mixins(TcwFormItemCommon) {
  @Prop({ default: '' })
  private value!: string
  @Prop({ default: '' })
  private activeText!: string
  @Prop({ default: '' })
  private inactiveText!: string

  @Emit()
  private input(_value: string): void {
    /**  */
  }
  @Emit()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private change(_value: string): void {
    /**  */
  }
  private select(selected: string): void {
    this.input(selected)
    this.change(selected)
  }
}
